
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/[id]",
      function () {
        return require("private-next-pages/groups/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/[id]"])
      });
    }
  